import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Form, Formik, FormikProps } from "formik";
import Button, { ButtonSizes, ButtonThemes } from "../../../../ui-components/button/button";
import FreightItemFormFields from "../../../common/freight-item/freightItemFormFields";
import { PickupItemSchema } from "../../../../app/data/pickup/models";
import { ItemModel } from "../../../../app/data/common/models";
import PickupState from "../../../../slices/pickup/PickupState";
import { pickupSelector } from "../../../../slices/pickup/pickupSlice";
import { freightItemValues } from "../../../../app/data/common/freightItem";

import "../../../../sass/forms.scss";

interface PickupItemFormProps {
  itemIndex?: number,
  editMode?: boolean;
  onCancel?: () => void,
  onSubmit: (data: ItemModel) => void
}

let initialValues: ItemModel = freightItemValues;

const PickupItemForm: React.FC<PickupItemFormProps> = (props) => {
  const {
    itemIndex,
    editMode,
    onCancel,
    onSubmit
  } = props;
  const pickupState: PickupState = useSelector(pickupSelector);
  const pickupItemRef = useRef<any>(null);

  useEffect(() => {
    if (itemIndex === undefined) {
      // Formik has issue when passing undefined values (https://github.com/formium/formik/issues/2332), so we passing empty strings  
      initialValues = freightItemValues;
      pickupItemRef.current.resetForm({ values: initialValues });
    } else {
      initialValues = {
        packageType: pickupState.items[itemIndex].packageType,
        commodityCode: pickupState.items[itemIndex].commodityCode,
        units: pickupState.items[itemIndex].units || "",
        yards: pickupState.items[itemIndex].yards || "",
        weight: pickupState.items[itemIndex].weight || "",
        length: pickupState.items[itemIndex].length || "",
        width: pickupState.items[itemIndex].width || "",
        diameter: pickupState.items[itemIndex].diameter || "",
        height: pickupState.items[itemIndex].height || "",
        ratingClass: pickupState.items[itemIndex].ratingClass || "",
        sidemark: pickupState.items[itemIndex].sidemark || "",
        notes: pickupState.items[itemIndex].notes || "",
      };
      pickupItemRef.current.resetForm({ values: initialValues });
    };
    // eslint-disable-next-line
  }, [itemIndex]);

  return (
    <div className="xgs-item-form">
      <Formik
        onSubmit={onSubmit}
        initialValues={initialValues}
        validationSchema={PickupItemSchema}
        innerRef={pickupItemRef}
        enableReinitialize
      >
        {(props: FormikProps<ItemModel>) => (
          <Form>
            <FreightItemFormFields />

            <div className="xgs-item-form__row xgs-item-form__row--buttons">
              <Button
                type="submit"
                theme={ButtonThemes.blue}
                size={ButtonSizes.autoMedium}
                disabled={
                  !props.isValid ||
                  !props.values.units ||
                  !!((editMode || itemIndex === undefined) && !props.dirty)
                }
                className="xgs-item-form__button"
              >
                {editMode ? "Save changes" : "Add Handling Unit"}
              </Button>
              {editMode && (
                <Button
                  type="button"
                  theme={ButtonThemes.blue}                  
                  onClick={onCancel}
                  className="xgs-item-form__button"
                >
                  Cancel
                </Button>
              )}
            </div>
          </Form>
        )}
      </Formik>      
    </div>
  );
};

export default PickupItemForm;